(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/teams/assets/javascripts/services/fetch-all-teams.js') >= 0) return;  svs.modules.push('/components/marketplace-data/teams/assets/javascripts/services/fetch-all-teams.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  roles,
  statuses
} = svs.components.marketplaceData.auth;
const {
  jupiter
} = svs.core;
const {
  normalizeGames
} = svs.components.marketplaceData.normalize;
const {
  mapper,
  types
} = svs.components.marketplaceData.teams.services.typeMapping;
const fetchAllTeams = callback => {
  jupiter.get("/marketplace/3/groups?count=999", response => {
    let teams = response.groups;
    const {
      customerId
    } = response;
    if (response.groups === null) {
      teams = [];
    }
    callback(undefined, teams.map(team => {
      var _team$currentUserAuto, _team$currentUserAuto2;
      const mappedTeam = _objectSpread({
        id: team.groupId,
        currentUser: {
          id: customerId,
          isMe: true,
          role: roles.getRole(team.currentUserRoleInGroup, statuses.getStatusById(team.currentUserStatusInGroup)),
          fractionSubscription: (_team$currentUserAuto = team.currentUserAutobuyin) !== null && _team$currentUserAuto !== void 0 && _team$currentUserAuto.maxWeeklyAmount ? Number((_team$currentUserAuto2 = team.currentUserAutobuyin) === null || _team$currentUserAuto2 === void 0 ? void 0 : _team$currentUserAuto2.maxWeeklyAmount) : null,
          status: statuses.getStatusById(team.currentUserStatusInGroup)
        },
        name: team.name,
        type: mapper[team.groupType],
        membersCount: team.numberOfMembers,
        role: roles.getRole(team.currentUserRoleInGroup, statuses.getStatusById(team.currentUserStatusInGroup)),
        isFollowing: true,
        token: team.token ? team.token.token : null,
        tokenExpires: team.token ? team.token.validUntil : null,
        games: normalizeGames(customerId, ...team.containersWithDraw),
        gamesAmount: team.numberOfContainersWithDraw
      }, team.city ? {
        city: team.city
      } : {});
      if (mappedTeam.type === types.RETAILER) {
        mappedTeam.coverImage = {
          path: team.imageId
        };
      }
      return mappedTeam;
    }));
  }, error => callback(error.responseJSON.error));
};
setGlobal('svs.components.marketplaceData.teams.services.fetchAllTeams', fetchAllTeams);
 })(window);